import { useState } from "react";
import type { Account } from "../types";
import type { ConfirmState } from "../components/ConfirmDialog";
import { viewRoutes, type View } from "./views";

/**
 * Moving between screens. A screen with unsaved changes (`settingsDirty`) asks before it is left.
 * A move rewrites the address bar, dropping any open `?transaction=` so the back button behaves.
 */
export function useNavigation({ view, setView, setAccountDetail, setConfirm }: {
  view: View;
  setView: (view: View) => void;
  setAccountDetail: (account: Account | null) => void;
  setConfirm: (confirm: ConfirmState | null) => void;
}) {
  const [settingsDirty, setSettingsDirty] = useState(false);
  function nav(v: View, discard = false) {
    if (settingsDirty && !discard && v !== view) {
      setConfirm({
        title: "Discard category changes?",
        message: "Your category changes have not been saved.",
        confirmLabel: "Discard changes",
        onConfirm: () => {
          setSettingsDirty(false);
          nav(v, true);
        },
      });
      return;
    }
    setView(v);
    setAccountDetail(null);
    if (window.location.pathname !== viewRoutes[v])
      window.history.pushState(
        null,
        "",
        viewRoutes[v] +
          window.location.search
            .replace(/([?&])transaction=[^&]*&?/, "$1")
            .replace(/[?&]$/, ""),
      );
    window.scrollTo({ top: 0 });
  }
  return { nav, setSettingsDirty };
}
